module.exports = __webpack_public_path__ + "media/images/icon/mail-6713ae753f619d334e0ca22ecd62ac06.svg";